<template>
  <div>
    <p
      class="page-header"
      v-text="group.GreetingText"
      data-cy="login-text-login"
    />
    <p v-html="toHtml(group.IntroText)"></p>

    <div class="row" v-if="group.Link1Url">
      <s-button
        id="ButtonReadMore"
        element-name="login-form-loginbutton"
        :small="true"
        color="blue"
        @click="goto(group.Link1Url)"
        >{{ group.Link1Text }}</s-button
      >
    </div>
    <div class="row mt10" v-if="group.Link2Url">
      <s-button
        id="ButtonFPI"
        element-name="login-form-loginbutton"
        :small="true"
        color="blue"
        @click="goto(group.Link2Url)"
        >{{ group.Link2Text }}</s-button
      >
    </div>

    <login-form
      :organization-id="group ? group.OrganizationId : '0'"
      :group-id="group ? group.Id : '0'"
      :redirect="redirect"
      :show-username="showUsername"
      class="mt20"
    ></login-form>
  </div>
</template>

<script>
import LoginForm from '@common/Components/Auth/Login';
import GroupModel from '@common/Models/GroupModel';
import { goto } from '@common/Helpers/externalLinks';
import { toHtml } from '@common/Helpers/markdown';

export default {
  components: {
    LoginForm
  },
  props: {
    redirect: String,
    showUsername: Boolean,
    group: {
      type: GroupModel
    }
  },
  methods: {
    goto,
    toHtml
  }
};
</script>

<style></style>
